import { tv } from '@change/ds-utils';

export const mainContainerStyles = tv({
	base: 'flex flex-col overflow-y-hidden border-[3px] border-[#999] bg-[white] py-[10px]',
	variants: {
		isExpanded: {
			false: 'h-[321px] w-[150px] rounded-[15px]',
			true: 'h-[535px] w-[250px] rounded-[24px]',
		},
	},
});

export const htmlContainerStyles = tv({
	base: 'leading-[140%] font-medium tracking-[-0.11px] whitespace-pre-wrap',
	variants: {
		isExpanded: {
			false: 'px-0 pt-[8px] text-[8px]!',
			true: 'px-1 pt-[11px] text-[13px]!',
		},
	},
});
